import { requests } from '../httpClient';

export const PcsEnrolment = {
    getPcsEnrolmentYearsAsync: () => requests.get(`PcsEnrolment`),
    enrolBasketAsync: (isCombinedPayment: boolean) => requests.post(`PcsEnrolment/EnrolBasket`, { combined: isCombinedPayment }),
    canPayMembershipAsync: () => requests.get(`PcsEnrolment/CanPayMembership`),
    finalisePaymentCheckAsync: () => requests.post(`PcsEnrolment/FinalisePaymentCheck`, {})
};
